module.exports = __webpack_public_path__ + "static/media/view-primary.14775843.svg";